import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { AppCenterPopupD2, CenterPopupHeaderD2, TxPinVerification } from "src/component"
import { FaRegMoneyBillAlt } from "react-icons/fa"
import ApiContext from "src/provider/API/call-service"
import { moneyFormat } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { Design } from "src/model"

export const RepayLoan: React.FC<any> = ({back,close,details}:{back:()=>void, close:()=>void,details:LoanDetail}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState<Input>({LoanAccountNumber: 0,
        repaymentAmount: undefined,
        isTermination: false,
        liquidationType:'',
        PIN:''
    })
    const [disableAmount, setDisableAmount] = useState(false)

    const [view, setView] = useState('liquidate-loan')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'liquidationType') {
            if(e.target.value === 'Full Payment'){
            input['repaymentAmount'] = Number(details?.amountLeft)
            setDisableAmount(true)
            }else{
            input['repaymentAmount'] = Number(0)
            setDisableAmount(false)
            }
        }
        if(disableAmount){
            setDisableAmount(false)
        }
        setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
       const response = await API.repayLoan({
            isTermination: input.liquidationType === 'Full Payment' ? true : false,
            LoanAccountNumber: details?.number,
            PIN: input.PIN,
            repaymentAmount: input.repaymentAmount
        } as Input)
        if(response){
            notifier.show(`Loan Amount of ${input.repaymentAmount} Repayed Successfully`, null, 'success')
        }
        close()
    }

    const Container =({children}:{children: React.ReactNode}) => {
        switch(true){
            case institutionData.design === Design.DESIGN_2:
                return  (
                    <AppCenterPopupD2  zIndex='6' overflow='hidden' close={close}>
                        <CenterPopupHeaderD2 title='Repay Loan' close={close} />
                        {children}
                    </AppCenterPopupD2>)
            default:
                return( 
                    <SidePopupLayout close={close}>
                        <ScreenTitle textSize="2.2" fontWeight="700">Repay Loan</ScreenTitle>
                        {children}
                    </SidePopupLayout>)
        }
    }

    return (
        <>
            { view === 'liquidate-loan' &&
                <Container>
                    <CustomContainer topMargin='2.5'>
                        <GridContainer
                            bgColor="#E7F6F5" minHeight="6.2" padding="1"
                            leftPadding="2" rightPadding="2" radius="0.8"
                        >
                            <FlexRow>
                                <FaRegMoneyBillAlt style={{color: '#0D968F', fontSize: '2rem'}} />
                                <AppText textSize="1.2" color="#0A756F" leftMargin="1">
                                    Outstanding Loan Amount: 
                                    <AppSpan 
                                    textSize="1.2" 
                                    color="#0A756F" 
                                    fontWeight="600"
                                    >
                                        {moneyFormat(details.amountLeft, true,institutionData?.defaultCurrency)}
                                    </AppSpan>
                                </AppText>
                            </FlexRow>
                        </GridContainer>
                        <Form onSubmit={handleProceed} topMargin='2'>
                            <FormGroupWithIcon>
                                <label>Select Repayment Type</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='liquidationType'
                                        value={input.liquidationType}
                                        style={{color: input.liquidationType ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        required
                                    >
                                        <option value="">Select Repayment Type</option>
                                        <option value="Part Payment">Part Payment</option>
                                        <option value="Full Payment">Full Payment</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Amount (&#8358;)</label>
                                <input 
                                    placeholder='Enter Amount' 
                                    type='number'
                                    name='repaymentAmount'
                                    value={input.repaymentAmount}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                    disabled={disableAmount}
                                />
                            </FormGroup>
                            {/* <FormGroup>
                                <label>Loan Account</label>
                                <input 
                                    placeholder='Enter Loan Account Number' 
                                    type='number'
                                    name='LoanAccountNumber'
                                    value={input.LoanAccountNumber}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup> */}
                            <FlexRow justifyContent='flex-end' gap="1.5" topMargin='2.5'>
                                <Button 
                                    width='6.7' height='4' bgColor="#ffffff"
                                    borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                    onClick={back}
                                >
                                    Back
                                </Button>
                                <Button 
                                    width='12.4' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Make Payment
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </Container>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    onPinChange={(pin: string) => setInput({...input, PIN:pin})}
                    next={handleSubmit} 
                />
            }
        </>
    )
}

type Input = {
    LoanAccountNumber: number,
    repaymentAmount: number | undefined,
    isTermination: boolean,
    liquidationType: 'Part Payment' | 'Full Payment' | '',
    PIN: string
}


type LoanDetail = {
    number: number
    product: string
    loanAmount: number
    loanCycle: number
    interestRate: number
    monthlyInterestRate: number
    amountLeft: number
    nextPaymentDate: string
    maturityDate: string
    totalRepaymentAmount: number
    realLoanStatus: string
}